import React from "react";
import { Container, Typography, Box, Paper } from "@mui/material";

const TermsOfService: React.FC = () => {
  return (
    <Container maxWidth="md" sx={{ mt: 8 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography component="h1" variant="h4" gutterBottom align="center">
          Termos de Serviço
        </Typography>
        <Typography variant="h6" gutterBottom>
          1. Aceitação dos Termos
        </Typography>
        <Typography variant="body1" paragraph>
          Ao acessar e usar este site, você concorda em estar vinculado por estes Termos de Serviço e por todas as leis e regulamentos
          aplicáveis. Se você não concorda com qualquer um destes termos, está proibido de usar ou acessar este site.
        </Typography>
        <Typography variant="h6" gutterBottom>
          2. Uso da Licença
        </Typography>
        <Typography variant="body1" paragraph>
          É concedida permissão para baixar temporariamente uma cópia dos materiais (informações ou software) no site do Gerenciador de
          Senhas Fidelius para visualização pessoal, não comercial e transitória.
        </Typography>
        <Typography variant="h6" gutterBottom>
          3. Isenção de Responsabilidade
        </Typography>
        <Typography variant="body1" paragraph>
          Os materiais no site do Gerenciador de Senhas Fidelius são fornecidos "como estão". A plataforma não oferece garantias, expressas
          ou implícitas, e por este meio se isenta e nega todas as outras garantias, incluindo, sem limitação, garantias implícitas ou
          condições de comercialização, adequação a um fim específico ou não violação de propriedade intelectual.
        </Typography>
        <Typography variant="h6" gutterBottom>
          4. Limitações
        </Typography>
        <Typography variant="body1" paragraph>
          Em nenhuma circunstância o Gerenciador de Senhas Fidelius ou seus fornecedores serão responsáveis por quaisquer danos (incluindo,
          sem limitação, danos por perda de dados ou lucro, ou devido a interrupção de negócios) decorrentes do uso ou da incapacidade de
          usar os materiais no site.
        </Typography>
      </Paper>
    </Container>
  );
};

export default TermsOfService;
